import { useState } from 'react';
import { describeOpeningHours, formatOpeningSummary, OPENING_HOURS_ZONE } from '@shared/openingHours';

export function HoursBadge({
  openingHours,
  now = new Date(),
}: {
  openingHours?: string;
  now?: Date;
}) {
  const status = describeOpeningHours(openingHours, now, OPENING_HOURS_ZONE);
  if (!status) return null;
  return <span className={`hours-badge hours-badge--${status.kind}`}>{status.label}</span>;
}

/** Today's status on a place card. The week is behind Show more. */
export function PlaceHours({
  openingHours,
  now = new Date(),
}: {
  openingHours?: string;
  now?: Date;
}) {
  const status = describeOpeningHours(openingHours, now, OPENING_HOURS_ZONE);
  const [open, setOpen] = useState(false);
  if (!status) return null;
  return (
    <div className="place-hours">
      <p className={`place-hours__now place-hours__now--${status.kind}`}>{formatOpeningSummary(status)}</p>
      {open
        ? status.lines.map((line) => (
            <p key={line} className="place-hours__line">
              {line}
            </p>
          ))
        : null}
      {status.lines.length > 0 ? (
        <button
          type="button"
          className="rb-more"
          aria-expanded={open}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setOpen((value) => !value);
          }}
        >
          {open ? 'Show less' : 'Show more'}
        </button>
      ) : null}
    </div>
  );
}

export function OpeningHoursBlock({
  openingHours,
  now = new Date(),
}: {
  openingHours?: string;
  now?: Date;
}) {
  const status = describeOpeningHours(openingHours, now, OPENING_HOURS_ZONE);
  const [open, setOpen] = useState(false);
  if (!status) return null;
  const [first, ...rest] = status.lines;
  return (
    <div className="opening-hours">
      <div className="opening-hours__head">
        <strong>Opening hours</strong>
        <HoursBadge openingHours={openingHours} now={now} />
      </div>
      <p className="opening-hours__line">{first}</p>
      {rest.length > 0 && open ? rest.map((line) => (
        <p key={line} className="opening-hours__line">{line}</p>
      )) : null}
      {rest.length > 0 ? (
        <button type="button" className="rb-more" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
          {open ? 'Show less' : 'Show more'}
        </button>
      ) : null}
      <p className="event-source">Hours from OpenStreetMap. Portugal time.</p>
    </div>
  );
}
